import { render, staticRenderFns } from "./TranshipmentFinancialBarChart.vue?vue&type=template&id=0a8bbb82&scoped=true"
import script from "./TranshipmentFinancialBarChart.vue?vue&type=script&lang=js"
export * from "./TranshipmentFinancialBarChart.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentFinancialBarChart.vue?vue&type=style&index=0&id=0a8bbb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8bbb82",
  null
  
)

export default component.exports